export default __webpack_public_path__ + "static/media/ic_installment.0100e98b.svg";